<template>
    <v-container>
        <v-layout row>
            <h2 class="hidden-sm-and-down">{{ txc.title }}</h2>
        </v-layout>
        <v-layout column>
            <h5 class="cardSectionTitle">{{ txc.acct_header }}</h5>
            <v-card flat>
                <v-card-text>
                    <section>
                        <div class="field-label">
                            {{ showEmailVerify 
                                ? `${sharedStrings.accounts.email_address} / ${sharedStrings.accounts.username}` 
                                : `${txc.email_header}`}}
                        </div>
                        <div class="field-value">{{ !showEmailVerify ? email : username }}</div>
                        <div class="field-edit" v-if="!showEmailVerify">
                            <a
                                id="editEmailDialogBtn"
                                href="#"
                                @click.stop="emailDialog = true"
                            >{{ txc.edit_email }}</a>
                        </div>
                        <edit-marketing-email-dialog 
                            v-if="emailDialog"
                            @closeDialog="emailDialog = false"
                            :isLegacy="!showEmailVerify"
                        />
                    </section>
                    <section v-if="marketLoggedIn != 'JP'">
                        <div class="field-label">{{ txc.mobile_number_header }}</div>
                        <div class="field-value">{{ mobileFormatted }}</div>
                        <div class="field-edit">
                            <a
                                id="editMobileNumberDialogBtn"
                                href="#"
                                @click.stop="mobileDialog = true"
                            >{{ txc.edit_mobile_number }}</a>
                        </div>
                        <edit-mobile-number-dialog v-if="mobileDialog" @closeDialog="mobileDialog = false" />
                    </section>
                </v-card-text>
            </v-card>
        </v-layout>
        <v-layout column>
            <h5 class="cardSectionTitle">{{ txc.promo_header }}</h5>
            <v-card flat class="mb-2">
                <v-card-text>
                    <section>
                        <div class="field-label">{{ txc.email_opt_in }}</div>
                        <div class="field-value mb-4" id="emailOptIn">{{ emailOptInLabel }}</div>
                        <div v-if="marketLoggedIn != 'JP'" class="field-label">
                            {{ txc.sms_opt_in }}
                        </div>
                        <div v-if="marketLoggedIn != 'JP'" class="field-value mb-4" id="SMSOptIn">
                            {{ SMSOptInLabel }}
                        </div>
                        <div class="field-edit">
                            <a
                                id="editCommunicationPreferenceDialogBtn"
                                href="#"
                                @click.stop="commPreferencesDialog = true"
                            >{{ txc.edit_comm_preferences }}</a>
                        </div>
                        <edit-communication-preference-dialog
                            v-if="commPreferencesDialog"
                            @closeDialog="commPreferencesDialog = false"
                        />
                    </section>
                </v-card-text>
            </v-card>
        </v-layout>
        <v-layout v-if="marketLoggedIn != 'JP'" column>
            <v-card flat class="mb-2">
                <v-card-text>
                    <section>
                        <div class="field-label">{{ txc.preferred_language }}</div>
                        <div class="field-value" ref="language_display">{{ prefLanguageDisplayName }}</div>
                        <div class="field-edit">
                            <a
                                id="editLanguageDialogBtn"
                                href="#"
                                @click.stop="openLangDialog"
                            >{{ txc.edit_pref_language }}</a>
                        </div>
                        <edit-language-preference-dialog
                            v-if="langDialog"
                            @closeDialog="langDialog = false"
                        />
                    </section>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import * as ruleSet from '../repositories/globalRules.js';

import EditCommunicationPreferenceDialog from './forms/EditCommunicationPreferenceDialog';
import EditMobileNumberDialog from './forms/EditMobileNumberDialog';
import EditLanguagePreferenceDialog from './forms/EditLanguagePreferenceDialog';
import EditMarketingEmailDialog from './forms/EditMarketingEmailDialog';
import { UsesFeatureFlags } from '@nuskin/ns-feature-flags-vue'

import { mapGetters } from 'vuex';
import profileUtils from '../repositories/profileUtils';
import {UserService} from '@nuskin/ns-account';

export default {
    name: 'Communications',
    components: {
        EditMobileNumberDialog,
        EditCommunicationPreferenceDialog,
        EditLanguagePreferenceDialog,
        EditMarketingEmailDialog
    },
    mixins: [UsesFeatureFlags],
    data() {
        return {
            user: {},
            account: {
                phoneNumbers: {
                    mobile: {
                        value: ''
                    }
                }
            },
            username:'',
            mobileDialog: false,
            langDialog: false,
            dialogError: null,
            commPreferencesDialog: false,
            acceptTandC: false,
            emailDialog: false,
            emailAddressForm: true,
            ruleSet
        };
    },
    computed: {
        ...mapGetters({
            languageLoggedIn: 'languageLoggedIn',
            marketLoggedIn: 'marketLoggedIn',
            fullScreenModals: 'mobileView',
            sharedStrings: 'sharedStrings',
            txc: 'translationsCommunication',
            email: 'email',
            isHomeMarket: 'isHomeMarket',
            mobileNumber: 'mobileNumber',
            mobileFormatted: 'mobileFormatted',
            acceptMarketingSMS: 'acceptMarketingSMS',
            acceptMarketingEmail: 'acceptMarketingEmail',
            preferredLanguage: 'preferredLanguage',
            country: 'country',
            prefLanguageDisplayName: 'prefLanguageDisplayName',
            marketConfigBooleanByName: 'marketConfigBooleanByName',
            phoneCountries: 'phoneCountries'
        }),
        emailOptInLabel() {
            return this.acceptMarketingEmail ? this.sharedStrings.generic.yes : this.sharedStrings.generic.no;
        },
        SMSOptInLabel() {
            return this.acceptMarketingSMS ? this.sharedStrings.generic.yes : this.sharedStrings.generic.no;
        },
        primaryEmail(){
            return UserService.getUser().email;
        },
        showEmailVerify() {
            return Boolean(this.featureEnabled('cx13-15592-enable-email-verify-feature'))
        }
    },
    methods: {
        openLangDialog() {
            this.langDialog = true;
            profileUtils.publishAnalytics(
                this.$analytics.category.communications,
                'language_preference_dialog',
                'opened'
            );
        }
    },
    mounted() {
        this.username = UserService.getUser().username;
        if (this.username === undefined) {
            this.username = UserService.getUser().email;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/colors';
.field-value {
    &.mb15 {
        margin-bottom: 20px;
    }
    &.disabled { 
        color: map.get(colors.$baseColors, "steel");
        font-style: italic;
    }
}
.pulledges {
  margin: 0 10px;
}

.checkboxes {
  margin: 0 10px;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
